import React from 'react';
import AnimatedSection from '../../AnimatedSection'
import './welcome.css';

const Welcome = () => {
  return (
    <>
      <div className="welcome-section">
        <div className="welcome-section-img">
        </div>
        
        <div className="welcome-section-info">
          <AnimatedSection x={-50} y={0} amount={0.5}>
            <div className="welcome-section-title">
              <h2>Doğayla İç İçe Güvenli Lojmanlar</h2>
            </div>
          </AnimatedSection>
          
          <AnimatedSection x={50} y={0} amount={0.5}>
            <div className="welcome-section-text">
              <p>Yeşillik dostu çevresiyle doğanın huzurunu hissettirirken, sosyal alanlara yakınlığı sayesinde ihtiyaçlarınıza kolayca ulaşabilirsiniz. 7/24 güvenlik hizmetiyle huzurlu ve güvenli bir yaşam sunan lojmanlarımız, modern tasarımı ve konforuyla üniversite hayatınızı bir adım öteye taşıyor.</p>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </>
  );
};

export default Welcome;
